module.exports = __webpack_public_path__ + "img/leaderboards.d63f5248.png";